const setDocumentReferrer = (ref: string) => {
  if (document.referrer !== ref) {
    Object.defineProperty(document, 'referrer', {
      configurable: true,
      get() {
        return ref
      },
    })
  }
  return null
}

export default setDocumentReferrer
